<template>
  <div>
    <weibo-list v-if="weiboListFlag" :weiboListFlag="weiboListFlag" @changeView = "changeView"></weibo-list>
    <code-authorize v-else :weiboListFlag="weiboListFlag" @changeView = "changeView"></code-authorize>
  </div>
</template>
<script>
import WeiboList from './weibo'
import CodeAuthorize from './codeAuthorize'

export default {
  name: '',
  data() {
    return {
      weiboListFlag: true
    }
  },
  components: {
    WeiboList,
    CodeAuthorize
  },
  methods: {
    changeView(flag) {
      this.weiboListFlag = flag
    }
  }
}
</script>
